import { render, staticRenderFns } from "./black-vip-zone-section4.vue?vue&type=template&id=392e63ea&scoped=true&"
import script from "./black-vip-zone-section4.vue?vue&type=script&lang=js&"
export * from "./black-vip-zone-section4.vue?vue&type=script&lang=js&"
import style0 from "./black-vip-zone-section4.vue?vue&type=style&index=0&id=392e63ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392e63ea",
  null
  
)

export default component.exports